<template>
  <div>
    <div class="bottom-top" v-if="roadName=='高速' && tab == '0'">
      <h4>
        <img src="../../../../assets/images/title.png">
        <span>说明</span>
      </h4>
      <div>1.统计逻辑：对重点的54条高速道路按区县进行分段，区分车辆吨位区间、燃料类型，统计各分段的日均运营车次和日均运营里程。</div>
      <div>2.省市区：可逐级选择，或输入关键词模糊搜索。筛选项支持多选。</div>
      <div>3.吨位区间：以车辆总质量的吨位数进行区间划分。筛选项支持多选。</div>
      <div>4.燃料类型：根据车辆燃料类型进行划分。筛选项支持多选。</div>
      <div>5.道路编码：可输入道路编码筛选。道路编码：G1、G2、G3、G4、G5、G6、G7、G10、G11、G12、G15、G16、G18、G20、G22、G25、G30、G35、G36、G40、G42、G45、G50、G55、G56、G59、G60、G65、G70、G72、G75、G76、G78、G80、G85、G69、G91、G92、G93、G94、G95、G98、G9901、G9902、G9903、G9904、G9905、G9906、G9907、G9908、G9909、G9910、G9911、G9912。</div>
      <div>6.日均运营车次：该道路上的车辆运营次数汇总÷统计周期内天数。【注】1辆车在某条道路分段1天途经多次计为1次。</div>
      <div>7.日均运营里程：该道路上的车辆运营里程数汇总÷统计周期内天数。</div>
      <div>8.统计频率：按周统计，每周日晚更新上周日至本周六数据。</div>
    </div>
    <div class="bottom-top" v-if="roadName=='高速' && tab == '1'">
      <h4>
        <img src="../../../../assets/images/title.png">
        <span>说明</span>
      </h4>

      <div>1.统计逻辑：对重点的54条高速道路按区县进行分段，按车辆吨位区间、燃料类型、站点类型，分别统计各分段的各品牌加能站车辆停靠次数。</div>
      <div>2.省市区：可逐级选择，或输入关键词模糊搜索。筛选项支持多选。</div>
      <div>3.吨位区间：以车辆总质量的吨位数进行区间划分。筛选项支持多选。</div>
      <div>4.燃料类型：根据车辆燃料类型进行划分。筛选项支持多选。</div>
      <div>5.站点类型：①加油站：仅支持加油；②加气站：仅支持加气；③加氢站：仅支持加氢；④加油加气站：同时支持加油和加气。筛选项支持多选。</div>
      <div>6.道路编码：可输入道路编码筛选。道路编码：G1、G2、G3、G4、G5、G6、G7、G10、G11、G12、G15、G16、G18、G20、G22、G25、G30、G35、G36、G40、G42、G45、G50、G55、G56、G59、G60、G65、G70、G72、G75、G76、G78、G80、G85、G69、G91、G92、G93、G94、G95、G98、G9901、G9902、G9903、G9904、G9905、G9906、G9907、G9908、G9909、G9910、G9911、G9912。</div>
      <div>7.停靠次数：各分段上的各品牌加能站车辆停靠次数。【注】一辆车在同个加能站一天停靠多次计为一次；停靠统计时长范围为3分钟-2小时。</div>
      <div>8.统计频率：按周统计，每周日晚更新上周日至本周六数据。</div>

    </div>
    <div class="bottom-top" v-if="roadName=='高速' && tab == '2'">
      <h4>
        <img src="../../../../assets/images/title.png">
        <span>说明</span>
      </h4>
      <div>1.统计逻辑：按车辆吨位区间、燃料类型、站点类型、站点品牌，分别统计54条主要高速道路上的各加能站对应的站前流量、站内停靠和进站率。</div>
      <div>2.省市区：可逐级选择，或输入关键词模糊搜索。筛选项支持多选。</div>
      <div>3.吨位区间：以车辆总质量的吨位数进行区间划分。筛选项支持多选。</div>
      <div>4.燃料类型：根据车辆燃料类型进行划分。筛选项支持多选。</div>
      <div>5.站点类型：①加油站：仅支持加油；②加气站：仅支持加气；③加氢站：仅支持加氢；④加油加气站：同时支持加油和加气。筛选项支持多选。</div>
      <div>6.站前流量：车辆途经加能站附近导航距离500米道路的次数汇总。【注】一辆车一天途经多次计为一次。</div>
      <div>7.站内停靠：该加能站车辆停靠次数汇总。【注】一辆车在同个加能站一天停靠多次计为一次；停靠统计时长范围为3分钟-2小时。</div>
      <div>8.进站率：站内停靠÷站前流量。</div>
      <div>9.统计频率：按周统计，每周日晚更新上周日至本周六数据。</div>
      <div>【注】如您发现某个加能站相关信息需要更新，请联系省级管理员或中交兴路顾问。</div>
    </div>
    <div class="bottom-top" v-if="roadName=='国道' && tab == '0'">
      <h4>
        <img src="../../../../assets/images/title.png">
        <span>说明</span>
      </h4>

      <div>1.统计逻辑：对重点的119条国道按区县进行分段，区分车辆吨位区间、燃料类型，统计各分段的日均运营车次和日均运营里程。</div>
      <div>2.省市区：可逐级选择，或输入关键词模糊搜索。筛选项支持多选。</div>
      <div>3.吨位区间：以车辆总质量的吨位数进行区间划分。筛选项支持多选。</div>
      <div>4.燃料类型：根据车辆燃料类型进行划分。筛选项支持多选。</div>
      <div>5.道路编码：可输入道路编码筛选。道路编码：G101、G102、G103、G104、G105、G106、G107、G108、G109、G110、G111、G112、G201、G202、G203、G204、G205、G206、G207、G208、G209、G210、G211、G212、G213、G214、G215、G216、G217、G218、G219、G220、G221、G222、G225、G227、G228、G229、G230、G231、G232、G233、G234、G235、G236、G237、G238、G239、G240、G241、G242、G243、G244、G245、G246、G247、G248、G301、G302、G303、G304、G305、G306、G307、G308、G309、G310、G311、G312、G314、G315、G316、G317、G318、G319、G320、G321、G322、G323、G324、G325、G326、G327、G328、G329、G330、G331、G332、G333、G334、G335、G336、G337、G338、G339、G340、G341、G342、G343、G344、G345、G346、G347、G348、G350、G351、G352、G353、G354、G355、G356、G357、G358、G359、G223、G224、G349、G360、G361。</div>
      <div>6.日均运营车次：该道路上的车辆运营次数汇总÷统计周期内天数。【注】1辆车在某条道路分段1天途经多次计为1次。</div>
      <div>7.日均运营里程：该道路上的车辆运营里程数汇总÷统计周期内天数。</div>
      <div>8.统计频率：按周统计，每周日晚更新上周日至本周六数据。</div>

    </div>
    <div class="bottom-top" v-if="roadName=='国道' && tab == '1'">
      <h4>
        <img src="../../../../assets/images/title.png">
        <span>说明</span>
      </h4>

      <div>1.统计逻辑：对重点的119条国道按区县进行分段，区分车辆吨位区间、燃料类型、站点类型，统计各分段的各品牌加能站停靠次数。</div>
      <div>2.省市区：可逐级选择，或输入关键词模糊搜索。筛选项支持多选。</div>
      <div>3.吨位区间：以车辆总质量的吨位数进行区间划分。筛选项支持多选。</div>
      <div>4.燃料类型：根据车辆燃料类型进行划分。筛选项支持多选。</div>
      <div>5.站点类型：①加油站：仅支持加油；②加气站：仅支持加气；③加氢站：仅支持加氢；④加油加气站：同时支持加油和加气。筛选项支持多选。</div>
      <div>6.道路编码：可输入道路编码筛选。道路编码：G101、G102、G103、G104、G105、G106、G107、G108、G109、G110、G111、G112、G201、G202、G203、G204、G205、G206、G207、G208、G209、G210、G211、G212、G213、G214、G215、G216、G217、G218、G219、G220、G221、G222、G225、G227、G228、G229、G230、G231、G232、G233、G234、G235、G236、G237、G238、G239、G240、G241、G242、G243、G244、G245、G246、G247、G248、G301、G302、G303、G304、G305、G306、G307、G308、G309、G310、G311、G312、G314、G315、G316、G317、G318、G319、G320、G321、G322、G323、G324、G325、G326、G327、G328、G329、G330、G331、G332、G333、G334、G335、G336、G337、G338、G339、G340、G341、G342、G343、G344、G345、G346、G347、G348、G350、G351、G352、G353、G354、G355、G356、G357、G358、G359、G223、G224、G349、G360、G361。</div>
      <div>7.停靠次数：各分段上的各品牌加能站车辆停靠次数。【注】一辆车在同个加能站一天停靠多次计为一次；停靠统计时长范围为3分钟-2小时。</div>
      <div>8.统计频率：按周统计，每周日晚更新上周日至本周六数据。</div>

    </div>
    <div class="bottom-top" v-if="roadName=='国道' && tab == '2'">
      <h4>
        <img src="../../../../assets/images/title.png">
        <span>说明</span>
      </h4>
      <div>1.统计逻辑：按车辆吨位区间、燃料类型、站点类型、站点品牌，分别统计119条主要国道上的各加能站对应的站前流量、站内停靠和进站率。</div>
      <div>2.省市区：可逐级选择，或输入关键词模糊搜索。筛选项支持多选。</div>
      <div>3.吨位区间：以车辆总质量的吨位数进行区间划分。筛选项支持多选。</div>
      <div>4.燃料类型：根据车辆燃料类型进行划分。筛选项支持多选。</div>
      <div>5.站点类型：①加油站：仅支持加油；②加气站：仅支持加气；③加氢站：仅支持加氢；④加油加气站：同时支持加油和加气。筛选项支持多选。</div>
      <div>6.站前流量：车辆途经加能站附近导航距离500米道路的次数汇总。【注】一辆车一天途经多次计为一次。</div>
      <div>7.站内停靠：该加能站车辆停靠次数汇总。【注】一辆车在同个加能站一天停靠多次计为一次；停靠统计时长范围为3分钟-2小时。</div>
      <div>8.进站率：站内停靠÷站前流量。</div>
      <div>9.统计频率：按周统计，每周日晚更新上周日至本周六数据。</div>
      <div>【注】如您发现某个加能站相关信息需要更新，请联系省级管理员或中交兴路顾问。</div>
    </div>
    <div class="bottom-top" v-if="roadName=='省道'">
      <h4>
        <img src="../../../../assets/images/title.png">
        <span>说明</span>
      </h4>
      <div>1、行驶车辆数：在该{{roadName}}上行驶过的货运平台车辆数总和；</div>
      <div>2、运营里程：货运平台车辆在该{{roadName}}上行驶里程总和；</div>
      <div>3、停靠小计：货运平台车辆在该{{roadName}}上所有油站的停靠次数总和，各品牌油站停靠统计同此规则；</div>
      <div>4、运营车次小计：每辆车每天在该{{roadName}}上运营过记一次（辆）；</div>
      <div>5、各时间段运营车次：每辆车每天该时间段在该{{roadName}}上运营过记1次（辆）；</div>
      <div>6、注册省：本省在货运平台登记入网的车辆数。</div>
    </div>
  </div>
</template>

<script>
import nameMixin from './nameMixin'
export default {
  props: {
    tab: {
      type: Number,
      default: 0
    }
  },
  mixins: [nameMixin],
}
</script>
